// Client lib imports
const { send: ajax } = require('client/lib/request')
// Client V2 common imports
const { NextPageStateEnum } = require('client-v2/common/utils/enums')
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
// Entry imports
const collectionEditModalActions = require('client-v2/collection-profile/containers/collection-edit-modal/actions')
const collectionEditModalSelectors = require('client-v2/collection-profile/containers/collection-edit-modal/selectors')
// Sibling imports
const selectors = require('./selectors')

const COVER_IMAGES_PAGE_SIZE = 20

// Action types

const SHOW = 'COLLECTION_EDIT_COVER_IMAGE_MODAL_SHOW'
const HIDE = 'COLLECTION_EDIT_COVER_IMAGE_MODAL_HIDE'
const FETCH_PENDING = 'COLLECTION_EDIT_COVER_IMAGE_MODAL_IMAGES_FETCH_PENDING'
const FETCH_SUCCESS = 'COLLECTION_EDIT_COVER_IMAGE_MODAL_IMAGES_FETCH_SUCCESS'
const FETCH_FAILED = 'COLLECTION_EDIT_COVER_IMAGE_MODAL_IMAGES_FETCH_FAILED'

// Action creators

function hide() {
  return {
    type: HIDE
  }
}

// Action dispatchers

function show(payload) {
  return async function (dispatch) {
    dispatch({
      type: SHOW,
      payload
    })
    dispatch(fetchImages())
  }
}

function deleteCoverImage() {
  return updateCoverImage('')
}

function toggleCoverImage(newCoverImage) {
  return function (dispatch, getState) {
    const state = getState()
    if (collectionEditModalSelectors.isPending(state)) {
      return
    }
    const oldCoverImage = collectionEditModalSelectors.coverImage(state)
    if (oldCoverImage === newCoverImage) {
      return dispatch(deleteCoverImage())
    }
    return dispatch(updateCoverImage(newCoverImage))
  }
}

function updateCoverImage(coverImage) {
  return collectionEditModalActions.updateCollection({
    'cover_image_url': coverImage
  })
}

function fetchImages() {
  return async function (dispatch, getState) {
    const state = getState()
    if (selectors.isNextPagePending(state)) {
      return
    }
    const collection = collectionEditModalSelectors.collection(state)
    const nextPage = selectors.nextPageNumber(state)
    dispatch({
      type: FETCH_PENDING
    })
    try {
      const result = await ajax({
        url: `/api/v0.1/mix/${collection.id}/posts/${nextPage}`,
        method: 'get'
      })
      // Assume that a full page of content means that there are more pages available
      const isMoreAvailable = result.items.length === COVER_IMAGES_PAGE_SIZE
      dispatch({
        type: FETCH_SUCCESS,
        payload: {
          items: result.items.map(i => i.thumbnailImage).filter(Boolean),
          nextPage: isMoreAvailable ? result.meta.nextPage : null,
          state: isMoreAvailable ? NextPageStateEnum.AVAILABLE : NextPageStateEnum.UNAVAILABLE
        }
      })
    } catch (err) {
      dispatch({
        type: FETCH_FAILED
      })
      dispatch(confirmModalActions.alert({
        heading: 'Could not fetch cover images',
        subheading: err.message
      }))
      throw err
    }
  }
}

module.exports = {
  // Action types
  FETCH_PENDING,
  FETCH_SUCCESS,
  FETCH_FAILED,
  HIDE,
  SHOW,
  // Action creators
  hide,
  // Action dispatchers
  deleteCoverImage,
  fetchImages,
  show,
  toggleCoverImage,
  updateCoverImage
}
